import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { AuthProvider } from './auth/AuthProvider';
import { JobTrackerProvider } from './providers/JobTrackerProvider';
import JobTrackerPanel from './components/Layout/JobTrackerPanel';
import ViewCredentials from './components/Credentials/ViewCredentials';
import './styles/globals.css';

// Check if we're on the public credentials route (no auth needed)
const isPublicCredentialsRoute = window.location.pathname.startsWith('/credentials/');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {isPublicCredentialsRoute ? (
        // Public route - no AuthProvider needed
        <Routes>
          <Route path="/credentials/:token" element={<ViewCredentials />} />
        </Routes>
      ) : (
        // Protected routes - use AuthProvider
        <AuthProvider>
          <JobTrackerProvider>
          <App />
          <JobTrackerPanel />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#10B981',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#EF4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </JobTrackerProvider>
        </AuthProvider>
      )}
    </BrowserRouter>
  </React.StrictMode>
);
